import api from '../lib/api';

const achievementService = {
    getMyAchievements: async () => {
        try {
            const response = await api.get('/achievements');
            return response.data;
        } catch (error) {
            console.error('Error fetching achievements:', error);
            throw error;
        }
    },

    getAllAchievements: async () => {
        try {
            const response = await api.get('/achievements/all');
            return response.data;
        } catch (error) {
            console.error('Error fetching all achievements:', error);
            throw error;
        }
    },

    getStatistics: async () => {
        try {
            const response = await api.get('/achievements/statistics');
            return response.data;
        } catch (error) {
            console.error('Error fetching achievement statistics:', error);
            throw error;
        }
    }
};

export default achievementService;

